
namespace GeniuzPOS.Customer {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class CsCustomerDialog extends Serenity.EntityDialog<CsCustomerRow, any> {
        protected getFormKey() { return CsCustomerForm.formKey; }
        protected getIdProperty() { return CsCustomerRow.idProperty; }
        protected getLocalTextPrefix() { return CsCustomerRow.localTextPrefix; }
        protected getNameProperty() { return CsCustomerRow.nameProperty; }
        protected getService() { return CsCustomerService.baseUrl; }
        protected getDeletePermission() { return CsCustomerRow.deletePermission; }
        protected getInsertPermission() { return CsCustomerRow.insertPermission; }
        protected getUpdatePermission() { return CsCustomerRow.updatePermission; }

        protected form = new CsCustomerForm(this.idPrefix);

        constructor() {
            super();
            if (this.isNew) {
                this.form.CustName.changeSelect2(e => {
                    var name = Q.toId(this.form.CustName.value);
                    if (name != null) {

                        this.form.CustRegName.value = this.form.CustName.value;
                        this.form.ShipName.value = this.form.CustName.value;                        
                    }
                });
                this.form.Address.changeSelect2(e => {
                    var add = Q.toId(this.form.Address.value);
                    if (add != null) {


                        this.form.CustRegAddress.value = this.form.Address.value;
                        this.form.ShipAddress.value = this.form.Address.value;
                        this.form.CustRegAdd1.value = this.form.Address.value;
                        this.form.ShipAddLine1.value = this.form.Address.value;

                    }
                });
                this.form.Tumbol.changeSelect2(e => {
                    var add = Q.toId(this.form.Tumbol.value);
                    if (add != null) {


                        this.form.CustRegTumbol.value = this.form.Tumbol.value;
                        this.form.ShipTumbol.value = this.form.Tumbol.value;
                        this.form.CustRegAdd2.value = this.form.Tumbol.value+"  "+this.form.Amphur.value;
                        this.form.ShipAddLine2.value = this.form.Tumbol.value+"  "+this.form.Amphur.value;

                    }
                });
                this.form.Amphur.changeSelect2(e => {
                    var add = Q.toId(this.form.Amphur.value);
                    if (add != null) {


                        this.form.CustRegAmphur.value = this.form.Amphur.value;
                        this.form.ShipAmphur.value = this.form.Amphur.value;
                        this.form.CustRegAdd2.value = this.form.Tumbol.value+"  "+this.form.Amphur.value;
                        this.form.ShipAddLine2.value = this.form.Tumbol.value+"  "+this.form.Amphur.value;


                    }
                });
                this.form.Province.changeSelect2(e => {
                    var add = Q.toId(this.form.Province.value);
                    if (add != null) {


                        this.form.CustRegProvince.value = this.form.Province.value;
                        this.form.ShipProvince.value = this.form.Province.value;
                        this.form.CustRegAdd3.value = this.form.Province.value+"  "+this.form.ZipCode.value;
                        this.form.ShipAddLine3.value = this.form.Province.value+"  "+this.form.ZipCode.value;


                    }
                });
                this.form.ZipCode.changeSelect2(e => {
                    var add = Q.toId(this.form.ZipCode.value);
                    if (add != null) {

                        this.form.CustRegZipCode.value = this.form.ZipCode.value;    
                        this.form.ShipZipCode.value = this.form.ZipCode.value;
                        this.form.CustRegAdd3.value = this.form.Province.value+"  "+this.form.ZipCode.value;
                        this.form.ShipAddLine3.value = this.form.Province.value+"  "+this.form.ZipCode.value;                 


                    }
                });
                this.form.Country.changeSelect2(e => {
                    var add = Q.toId(this.form.Country.value);
                    if (add != null) {

                        this.form.CustRegCountry.value = this.form.Country.value;    
                        this.form.ShipCountry.value = this.form.Country.value;
                        


                    }
                });

                //------ส่วน จดทะเบียน------------
                this.form.CustRegAddress.changeSelect2(e => {
                    var add = Q.toId(this.form.CustRegAddress.value);
                    if (add != null) {
                        this.form.CustRegAdd1.value = this.form.CustRegAddress.value;
                        }
                });
                this.form.CustRegTumbol.changeSelect2(e => {
                    var add = Q.toId(this.form.CustRegTumbol.value);
                    if (add != null) {
                        this.form.CustRegAdd2.value = this.form.CustRegTumbol.value+"  "+this.form.CustRegAmphur.value;
                        }
                });
                this.form.CustRegAmphur.changeSelect2(e => {
                    var add = Q.toId(this.form.CustRegAmphur.value);
                    if (add != null) {
                        this.form.CustRegAdd2.value = this.form.CustRegTumbol.value+"  "+this.form.CustRegAmphur.value;
                        }
                });
                this.form.CustRegProvince.changeSelect2(e => {
                    var add = Q.toId(this.form.CustRegProvince.value);
                    if (add != null) {
                        this.form.CustRegAdd3.value = this.form.CustRegProvince.value+"  "+this.form.CustRegZipCode.value;
                        }
                });
                this.form.CustRegZipCode.changeSelect2(e => {
                    var add = Q.toId(this.form.CustRegZipCode.value);
                    if (add != null) {
                        this.form.CustRegAdd3.value = this.form.CustRegProvince.value+"  "+this.form.CustRegZipCode.value;
                        }
                });

                //------ส่วน ส่งสินค้า------------
                this.form.ShipAddress.changeSelect2(e => {
                    var add = Q.toId(this.form.ShipAddress.value);
                    if (add != null) {
                        this.form.ShipAddLine1.value = this.form.ShipAddress.value;
                        }
                });
                this.form.ShipTumbol.changeSelect2(e => {
                    var add = Q.toId(this.form.ShipTumbol.value);
                    if (add != null) {
                        this.form.ShipAddLine2.value = this.form.ShipTumbol.value+"  "+this.form.ShipAmphur.value;
                        }
                });
                this.form.ShipAmphur.changeSelect2(e => {
                    var add = Q.toId(this.form.ShipAmphur.value);
                    if (add != null) {
                        this.form.ShipAddLine2.value = this.form.ShipTumbol.value+"  "+this.form.ShipAmphur.value;
                        }
                });
                this.form.ShipProvince.changeSelect2(e => {
                    var add = Q.toId(this.form.ShipProvince.value);
                    if (add != null) {
                        this.form.ShipAddLine3.value = this.form.ShipProvince.value+"  "+this.form.ShipZipCode.value;
                        }
                });
                this.form.ShipZipCode.changeSelect2(e => {
                    var add = Q.toId(this.form.ShipZipCode.value);
                    if (add != null) {
                        this.form.ShipAddLine3.value = this.form.ShipProvince.value+"  "+this.form.ShipZipCode.value;
                        }
                });
            }
        }
        //จบ cont
        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Idd = Q.tryFirst(Inventory.IcStockSoldRow.getLookup().items, x => x.StockTo == this.entity.CustCode);
            if (Idd != null) {
                this.deleteButton.toggleClass('disabled', true);
            }

            var Iddd = Q.tryFirst(Inventory.IcStockReturnInRow.getLookup().items, x => x.StockFrom == this.entity.CustCode);
            if (Iddd != null) {
                this.deleteButton.toggleClass('disabled', true);
            }


        }

    }
}